module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrap"
  }, [_c('div', {
    ref: "bg",
    staticClass: "menu-background"
  }), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    ref: "content",
    staticClass: "menu-content"
  }, [_c('div', {
    staticClass: "menu-grid",
    class: _vm.gridSize
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.links), function(link) {
    return _c('li', {
      ref: "links",
      refInFor: true,
      staticClass: "menu-list__item"
    }, [_c('router-link', {
      staticClass: "menu-list__link",
      attrs: {
        "to": '/' + _vm.lang + link.url
      },
      nativeOn: {
        "click": function($event) {
          _vm.onLinkClick($event)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(link.name))])])], 1)
  })), _c('footer', {
    staticClass: "menu-bottom"
  }, [_c('ul', {
    staticClass: "social"
  }, _vm._l((_vm.social), function(item) {
    return (_vm.$t(item.name + '-link').length > 0) ? _c('li', {
      ref: "social",
      refInFor: true,
      staticClass: "social__item"
    }, [_c('a', {
      staticClass: "social__link",
      attrs: {
        "href": _vm.$t(item.name + '-link'),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "social__icon",
      class: ("is-" + (item.name)),
      attrs: {
        "src": item.image,
        "alt": ((item.name) + " logo")
      }
    })])]) : _vm._e()
  }))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09ed8366","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/the-menu.vue
// module id = 465
// module chunks = 0